

import mixx from "../../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  name: "terminales",
  data() {
    return {
      loading: false,
      result_upload: 555,
      message_err: "Aqui se visualizará el resultado de la importación.",
      tarea: "",
      cols_r: [],
      cols_fd: ["AAAAAA", "BBBBB", "CCCCC", "DDDDD", "EEEE"],
      relaciones: []
    };
  },
  computed: {},
  mounted: function() {
    $(".box").boxWidget();
    this.get_columnas_fd();
  },

  methods: {
    allowDrop(ev) {
      ev.preventDefault();

      if (ev.target.getAttribute("dropzone") != "move") {
        ev.dataTransfer.dropEffect = "none";
      } else {
        ev.dataTransfer.dropEffect = "all";
      }
    },

    drop_rt(ev) {
      ev.preventDefault();

      let data = ev.dataTransfer.getData("ids");

      if (data != undefined && data != "") {
        if (ev.target.childNodes.length == 0) {
          ev.target.appendChild(document.getElementById(data));
        }
      }
    },

    drop(ev) {
      ev.preventDefault();
      let data = ev.dataTransfer.getData("ids");

      if (ev.target.childNodes.length == 0) {
        if (data != undefined && data != "") {
          ev.target.appendChild(document.getElementById(data));
        }
      }
    },

    drag(ev) {
      ev.dataTransfer.setData("ids", ev.target.id);
    },

    procesar() {
      this.loading = true;
      let ret = [];

      for (let i = 0; i < this.cols_fd.length; i++) {
        let chils = $("#" + i + "_cont")[0].childNodes;

        for (let d = 0; d < chils.length; d++) {
          let sp = chils[d].id.split("_");

          ret.push([i, parseInt(sp[0])]);
        }
      }

      this.relaciones = ret;

      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "setConcp",
            re: this.relaciones,
            cols: this.cols_r
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) {
            this.relaciones = [];

            this.message_err =
              "Se registro el proceso, le enviaremos una notificacion cuando la conciliacion se encuentre disponible.";
            this.showNotification({
              msj: this.message_err,
              bg: "bg-green"
            });
          }else if(response.data.status == 4){

            this.message_err =
            "Debe cargar un archivo nuevamente.";

          } else {
            this.message_err =
              "Se produjo un error al registrar el proceso, por favor reintente. Si el error persiste, contacte con soporte.";
            this.showNotification({
              msj: this.message_err,
              bg: "bg-red"
            });
          }

          this.loading = false;
        });
    },

    get_columnas_fd() {
      this.loading = true;
      this.cols_fd = [];

      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "getConCols"
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status == 1) {
            this.cols_fd = response.data.data;
          }

          this.loading = false;
        });
    },

    subir_txt() {
      this.relaciones = [];
      this.result_upload = 555;
      this.message_err = "Aqui se visualizará el resultado de la importación.";
      this.tarea = "";

      var formData = new FormData();
      var imagefile = document.querySelector("#file");
      formData.append("file", imagefile.files[0]);
      formData.append("a", "confie");

      if (imagefile.files[0] != undefined) {
        this.loading = true;
        this.$http
          .post("SERVER/scd/configs/", formData, {
            withCredentials: true,
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            this.result_upload = response.data.status;

            if (response.data.status == 1) {
              this.message_err =
                "Archivo cargado correctamente, ahora debe establecer la combinación de columnas: ";

              this.cols_r = response.data.cols;
            } else if (response.data.status == 4) {
              this.message_err = "EL tamaño del archivo supera el permitido.";
              this.showNotification({
                msj: this.message_err,
                bg: "bg-yellow"
              });
            } else if (response.data.status == 5) {
              this.message_err = "Solo se permiten archivos xls o xlsx";

              this.showNotification({
                msj: this.message_err,
                bg: "bg-yellow"
              });
            } else if (response.data.status == 6) {
              this.message_err = "No se pudo incorporar el archivo";

              this.showNotification({
                msj: this.message_err,
                bg: "bg-red"
              });
            } else {
              this.message_err =
                "Ocurrió un error al procesar el archivo, si este error persiste, contacte con soporte.";
              this.showNotification({
                msj: this.message_err,
                bg: "bg-red"
              });
            }

            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            this.showNotification({
              msj: "Error inesperado del servidor. Contacte con soporte.",
              bg: "bg-red"
            });
          });
      } else {
        this.showNotification({
          msj: "Verifique que el archivo se encuentre cargado.",
          bg: "bg-yellow"
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/configs/conciliador/main/index.js